import dayjs from "dayjs";

import { formHasErrors, setFormValues } from "./objectValidation";

const hasPatientIdentifier = (row) => Boolean(row?.patient_identifier?.trim());

const hasCompleteDemographics = (row) => {
    const firstName = row?.first_name?.trim() || "";
    const lastName = row?.last_name?.trim() || "";
    return firstName.length >= 2 && lastName.length >= 2 && row?.birth_date && dayjs(row.birth_date).isValid();
};

/**
 * Criteria:
 * 1) Required when no Patient ID, min 2 chars
 */
const firstNameValidation = (prevConfig, row, value) => {
    if (hasPatientIdentifier(row)) {
        if (value && value.trim().length > 0 && value.trim().length < 2) {
            return setFormValues(row, "first_name", true, "First name must be at least 2 characters.");
        }
        return setFormValues(row, "first_name", false, "");
    }

    if (!value || value.trim().length < 2) {
        return setFormValues(row, "first_name", true, "First name is required (min 2 characters).");
    }

    return setFormValues(row, "first_name", false, "");
};

/**
 * Criteria:
 * 1) Required when no Patient ID, min 2 chars
 */
const lastNameValidation = (prevConfig, row, value) => {
    if (hasPatientIdentifier(row)) {
        if (value && value.trim().length > 0 && value.trim().length < 2) {
            return setFormValues(row, "last_name", true, "Last name must be at least 2 characters.");
        }
        return setFormValues(row, "last_name", false, "");
    }

    if (!value || value.trim().length < 2) {
        return setFormValues(row, "last_name", true, "Last name is required (min 2 characters).");
    }

    return setFormValues(row, "last_name", false, "");
};

/**
 * Criteria:
 * 1) Required when no Patient ID
 * 2) Must be valid
 * 3) Must be in the past
 */
const birthDateValidation = (prevConfig, row, value) => {
    if (!hasPatientIdentifier(row) && (value === "" || value === null)) {
        return setFormValues(row, "birth_date", true, "Birth date is required when Patient ID is not provided.");
    }

    if (value === "" || value === null) {
        return setFormValues(row, "birth_date", false, "");
    }

    if (!dayjs(value).isValid()) {
        return setFormValues(row, "birth_date", true, "Invalid");
    }

    if (dayjs(value).isAfter(dayjs())) {
        return setFormValues(row, "birth_date", true, "Must be in the past");
    }

    return setFormValues(row, "birth_date", false, "");
};

/**
 * Criteria:
 * 1) Required when demographics are incomplete
 * 2) Reject empty values after trim
 */
const patientIdentifierValidation = (prevConfig, row, value) => {
    if (hasCompleteDemographics(row)) {
        if (value && !value.trim()) {
            return setFormValues(row, "patient_identifier", true, "Patient ID cannot be blank.");
        }
        return setFormValues(row, "patient_identifier", false, "");
    }

    if (!value || !value.trim()) {
        return setFormValues(row, "patient_identifier", true, "Patient ID is required when name and birth date are incomplete.");
    }

    return setFormValues(row, "patient_identifier", false, "");
};

// The main constant, directing to the specific validation function.
export const PATIENT_VALIDATION = {
    patient_identifier: {
        check: patientIdentifierValidation
    },
    first_name: {
        check: firstNameValidation
    },
    last_name: {
        check: lastNameValidation
    },
    birth_date: {
        check: birthDateValidation
    }
};

export const IS_PATIENT_VALID = (obj) => {
    return !formHasErrors(obj) && (hasPatientIdentifier(obj) || hasCompleteDemographics(obj));
};
